import api from '../config/axiosConfig';

export const DepartamentoService = {
  fetchDepartamentos: async (token) => {
    try {
      const response = await api.get('/locations/departments', {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      if (response.data.success) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error en DepartamentoService.fetchDepartamentos:", error);
      throw error;
    }
  },
};
